export const ROOT = "/admin/serial-number";

export const GENERATE_SN = `${ROOT}/generate`;
export const TAG_SN = `${ROOT}/tag`;
export const TAG_DETAILS_PAGE = `${ROOT}/tag/:uuid`;
export const LISTING_SN = `${ROOT}/listing`;
export const DETAILS_SN = `${ROOT}/details/:enc`;
export const BATCH_SN = `${ROOT}/batch`;
export const ADT_ADD_SN = `${ROOT}/additional-info/add-sn`;
